import Vue from 'vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import dayjs from 'dayjs';

import Countdown from '@/core/countdown';
import { TextField } from '@/core/fields';
import { OtpStatus } from '../../constants';

@Component({
    data() {
        return {
            validCode: false,
            Status: OtpStatus,
            isResendEnabled: true
        };
    },
    components: {
        TextField,
        Countdown
    }
})
export default class Otp extends Vue {
    @Ref() otpCodeField!: any;

    code: string = '';
    failedOnce: boolean = false;
    submittedCode: string = '';
    isResendEnabled: boolean;

    @Prop(Number)
    processStatus: number = OtpStatus.None;

    @Prop()
    mobile: string;

    @Prop()
    countryCode: string;

    @Prop(Boolean)
    isInvalid: boolean;

    @Prop(Boolean)
    otpLimitReached: boolean;

    @Prop(Number)
    timestamp: number;

    @Prop({ default: 600000, type: Number })
    requestThreshold: number;

    created() {
        if (this.getRemainingTime() > 0) {
            this.disableResend();
        } else {
            this.enableResend();
        }
    }

    get codeChanged() {
        return this.code.trim() === '' ||
            this.submittedCode.trim() === '' ||
            this.code !== this.submittedCode;
    }

    get loading() {
        return this.processStatus === OtpStatus.Pending;
    }

    async isOtpValid() {
        const valid = await this.otpCodeField?.provider?.validate();

        if (!valid || this.loading) {
            return false;
        }

        this.submittedCode = this.code;

        this.$emit('validate', this.code);

        return true;
    }

    get showError() {
        return this.processStatus === OtpStatus.InvalidOtp &&
            !this.codeChanged && !this.loading;
    }

    resend(e) {
        e.preventDefault();

        if (this.loading) {
            return;
        }

        if (this.getRemainingTime() > 0) {
            this.disableResend();
            return;
        }

        this.submittedCode = '';

        this.disableResend();

        this.$emit('resend');
    }

    disableResend() {
        this.isResendEnabled = false;
    }

    enableResend() {
        this.isResendEnabled = true;
    }

    get invalidOtp() {
        return this.processStatus === OtpStatus.InvalidOtp && !this.codeChanged;
    }

    get otpStyle() {
        return {
            'otp-invalid': this.invalidOtp && !this.loading,
            'otp-valid': !this.invalidOtp && !this.loading,
            'otp-loading': this.loading
        };
    }

    getRemainingTime() {
        const remainingTime = (this.requestThreshold - (dayjs(new Date()).valueOf() - this.timestamp));

        return remainingTime > 0 ? remainingTime : 0;
    }
}
